import n from "./ghl-ui.es406.js";
import o from "./ghl-ui.es407.js";
function m(e, t) {
  return e && e.length ? o(e, n(t)) : [];
}
export {
  m as default
};
